import { deriveBooleanValue } from 'tsx/libs/records';

import { faEdit } from '~components/icon';
import { buildColumn, EditableColumnConfig } from '~components/table-view';

const columnsList: EditableColumnConfig[] = [
  {
    id: 'full_name',
    header: 'Full Name',
    type: 'link',
    props: {
      meta: {
        link: ({ id }: any) => `/users/${id}`,
        hoverIcon: faEdit,
      },
    },
  },
  {
    id: 'date_last_login',
    header: 'Last Login',
    type: 'date',
  },
  {
    id: 'level.name',
    header: 'User Level',
    type: 'text',
    association: 'level',
  },
  {
    id: 'department.name',
    header: 'Team',
    type: 'text',
    association: 'department',
  },
  {
    id: 'suburb',
    header: 'Suburb',
    type: 'text',
  },
  {
    id: 'postcode',
    header: 'Postcode',
    type: 'text',
  },
  {
    id: 'gender.name',
    attribute: 'gender',
    header: 'Gender',
    type: 'text',
  },
  {
    id: 'accounts_access_enabled',
    header: 'Accounts Access Enabled',
    type: 'text',
    accessorFn: (row) => deriveBooleanValue(row.accounts_access_enabled as boolean),
  },
  {
    id: 'unlocking_permissions',
    header: 'Unlocking Allowed',
    type: 'text',
    accessorFn: (row) => deriveBooleanValue(row.unlocking_permissions as boolean),
  },
];

export default {
  attributes: Array.from(
    new Set(['id', ...columnsList.map(({ id, attribute }) => attribute ?? id)])
  ),
  associations: columnsList
    .map(({ association }) => association)
    .filter((a): a is string => Boolean(a)),
  displayList: columnsList.map(buildColumn),
}
